import { NotificationStatus } from '@shared/types/notifications.types'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import axiosClient from '../useAxios'

export const useUpdateNotificationMutation = (userId: string) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationKey: ['notifications', 'update'],
    mutationFn: async ({
      notificationId,
      data
    }: {
      notificationId: string
      data: { status: NotificationStatus }
    }): Promise<void> => {
      await axiosClient.patch(
        `/users/${userId}/notifications/${notificationId}`,
        data
      )
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['users', userId, 'notifications']
      })
    }
  })
}

export const useMarkAllNotificationsAsReadMutation = (userId: string) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationKey: ['notifications', 'mark-all-as-read'],
    mutationFn: async (userId: string): Promise<void> => {
      await axiosClient.patch(`/users/${userId}/notifications`)
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['users', userId, 'notifications']
      })
    }
  })
}

export const useDeleteNotificationsMutation = (userId: string) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationKey: ['notifications', 'delete'],
    mutationFn: async (data: { notificationId: string }): Promise<void> => {
      await axiosClient.delete(
        `/users/${userId}/notifications/${data.notificationId}`
      )
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['users', userId, 'notifications']
      })
    }
  })
}
